import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import BackendApi from '../BackendApi';
import CookieStor from '../CookieStor'
import AuthForm from '../components/AuthForm';



class SignIn extends Component {

  constructor(props){
		super(props);

		this.state = {
      login: '',
      password: '',
    };
  }
  

  submitForm = (e, authData) => {
    e.preventDefault()
		BackendApi.auth(authData).then((result) => {
      switch(result.status)
        {
          case 200:
            this.props.history.push('/video-list/');
            break;

          case 500:
            this.setState({password: 'Произошла непредвиденная ошибка, попробуйте снова'});
            break;
          
          default:
            let fieldErrors = {};
            for(let key in result.data) {
              Object.assign(fieldErrors, {[result.data[key].field]: result.data[key].message})
            }
            this.setState(fieldErrors)
        }
    })
  }

  changeInput = (nameField) => {
    this.setState({[nameField]: ''});
  }

  render() {
    
    if (CookieStor.getAccessToken()) {
      return <Redirect to='/video-list/'/>
    }

    return (
      <AuthForm 
        loginMessage={this.state.login} 
        passwordMessage={this.state.password} 
        submitForm={this.submitForm}
        changeInput={this.changeInput}
        />
    );
  }
}

export default SignIn;
